import offerCategories from '../../common/offerCategories.js';

export default function (categories) {
    const monthSymbol = categories.includes(offerCategories.AUTO_CREDIT) ||
        categories.includes(offerCategories.MORTGAGE) ||
        categories.includes(offerCategories.CONSUMER_LOAN) ||
        categories.includes(offerCategories.DEPOSIT) ||
        categories.includes(offerCategories.BAIL_LOAN);

    return monthSymbol ? 'мес.' : 'дн.';
}
